<template>
    <div class="mode-toggle">
        <input 
        type="checkbox" 
        id="darkmode-toggle" 
        :aria-label="$t('aria-labels.dark-mode')" 
        aria-checked="false" 
        role="switch"
        class="visually-hidden-focusable"
        />
        <label class="mode-toggle__switch" for="darkmode-toggle" aria-hidden="true" >
            <span
            v-if="isDarkMode" 
            class="btn-icon icon-darkmode"
            ></span>
            <span
            v-else 
            class="btn-icon icon-highlight"
            title="Activate dark mode"
            ></span>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'DarkModeToggle',
        data() {
            return {
                isDarkMode: false,
            };
        },
        mounted() {
            const toggleSwitch = document.getElementById('darkmode-toggle');            
            const currentTheme = localStorage.getItem('theme');
            
            this.isDarkMode = currentTheme === 'dark';
            document.documentElement.setAttribute('data-theme', currentTheme || 'light');

            toggleSwitch.checked = this.isDarkMode;
            toggleSwitch.setAttribute('aria-checked', this.isDarkMode);
            
            toggleSwitch.addEventListener('change', this.toggleDarkMode, false);
        },
        methods: {
            toggleDarkMode() {
                const toggleSwitch = document.getElementById('darkmode-toggle');
                this.isDarkMode = toggleSwitch.checked;
                const newTheme = this.isDarkMode ? 'dark' : 'light';
                
                localStorage.setItem('theme', newTheme);
                document.documentElement.setAttribute('data-theme', newTheme);
                toggleSwitch.setAttribute('aria-checked', this.isDarkMode);
                
                this.$emit('darkModeToggled', this.isDarkMode);
            }
        }
    };
</script>
